import { useEffect } from 'react';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import { useStore } from 'zustand';

export default function useOperatorsLoader() {
  const { store } = useChatWidgetContext();
  const subscription = useStore(store, (state) => state.widgetSubscription);
  const operators = useStore(store, (state) => state.operators);
  const operatorsLoaded = useStore(store, (state) => state.operatorsLoaded);

  useEffect(() => {
    if (operatorsLoaded) { return; }

    subscription.send({
      action_name: 'find_online_operators',
    });
  }, [operatorsLoaded, subscription]);

  return { operators };
}
